import { defineMessages } from "react-intl";

export const fileUploadText = defineMessages({
  addAttachmentText: { defaultMessage: "Add Attachment", id: "M9Oetk" },
});
